<div [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ANSCHLUSS_NETZBETREIBER"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Identifikator des Anschluß NB</mat-label>
      <input formControlName="anschlussNetzbetreiber"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anschlussNetzbetreiber"
        matInput
        name="sr_anschlussNetzbetreiber">
      @if (f.anschlussNetzbetreiber.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Marktpartner-ID des Anschluß NB ein.
        </mat-error>
      }
      @if (f.anschlussNetzbetreiber.hasError('pattern')) {
        <mat-error>
          Eine Marktpartner-ID besteht aus 13 Zeichen und startet mit einer Zahl zwischen 40 und 60 oder der 99.
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ANWEISENDER_NETZBETREIBER"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Identifikator des anweisenden NB</mat-label>
      <input formControlName="anweisenderNetzbetreiber"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anweisenderNetzbetreiber"
        matInput
        name="sr_anweisenderNetzbetreiber">
      @if (f.anweisenderNetzbetreiber.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Marktpartner-ID des anweisenden NB ein.
        </mat-error>
      }
      @if (f.anweisenderNetzbetreiber.hasError('pattern')) {
        <mat-error>
          Eine Marktpartner-ID besteht aus 13 Zeichen und startet mit einer Zahl zwischen 40 und 60 oder der 99.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_BETROFFENER_NETZBETREIBER"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Identifikator des betroffenen NB</mat-label>
      <input formControlName="betroffeneNetzbetreiber"
        [redispatchSplitter]="MP_SEPARATOR"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="betroffeneNetzbetreiber"
        matInput
        name="sr_betroffeneNetzbetreiber">
      @if (f.betroffeneNetzbetreiber.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine oder mehrere Marktpartner-ID's des betroffenen NB ein.
        </mat-error>
      }
      @if (f.betroffeneNetzbetreiber.hasError('length')) {
        <mat-error>
          Es dürfen maximal {{ MAX_AMOUNT_BETROFFENE_NB }} angegeben werden.
        </mat-error>
      }
      @if (f.betroffeneNetzbetreiber.hasError('pattern')) {
        <mat-error>
          Eine Marktpartner-ID besteht aus 13 Zeichen und startet mit einer Zahl zwischen 40 und 60 oder der 99.
          Mit ',' (Komma) getrennt.
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_WEITERE_BETROFFENE_NETZBETREIBER"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Identifikator der weiteren betroffenen NB</mat-label>
      <input formControlName="weitereBetroffeneNetzbetreiber"
        [redispatchSplitter]="MP_SEPARATOR"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="weitereBetroffeneNetzbetreiber"
        matInput
        name="sr_weitereBetroffeneNetzbetreiber">
      @if (f.weitereBetroffeneNetzbetreiber.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine oder mehrere Marktpartner-ID der weiteren betroffenen NB ein.
        </mat-error>
      }
      @if (f.weitereBetroffeneNetzbetreiber.hasError('pattern')) {
        <mat-error>
          Eine Marktpartner-ID besteht aus 13 Zeichen und startet mit einer Zahl zwischen 40 und 60 oder der 99.
          Mit ',' (Komma) getrennt.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ABRECHNUNGSKLASSE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Abrechnungsklasse</mat-label>
      <mat-select formControlName="abrechnungsklasse"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="abrechnungsklasse"
        name="sr_abrechnungsklasse">
        @for (item of AbrechnungsklasseItems; track item.key) {
          <mat-option
            [value]="item.key">{{ item.description }}
          </mat-option>
        }
      </mat-select>

      @if (f.abrechnungsklasse.hasError('required')) {
        <mat-error>
          Wählen Sie eine Abrechnungsklasse aus
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_BILANZIERUNGSMODELL"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Planwert-/Prognosemodell</mat-label>
      <mat-select formControlName="bilanzierungsmodell"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="bilanzierungsmodell"
        name="sr_bilanzierungsmodell">
        <mat-option [value]="null">-</mat-option>
        @for (item of BilanzierungsmodellItems; track item.key) {
          <mat-option
            [value]="item.key">{{ item.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_REGELZONE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Regelzone</mat-label>
      <mat-select formControlName="regelzone"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="regelzone"
        name="sr_regelzone">
        @for (item of RegelzoneItems; track item.key) {
          <mat-option
            [value]="item.key">{{ item.description }}
          </mat-option>
        }
      </mat-select>
      @if (f.regelzone.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Regelzone ein.
        </mat-error>
      }
    </mat-form-field>
  </div>
</div>
